import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const viewportConfig = { 
  threshold: 0.1,
  triggerOnce: false,
  rootMargin: "-50px 0px"
};

const containerVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut",
      staggerChildren: 0.15,
      when: "beforeChildren"
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};

const OfficeInfo = () => {
  const [ref, inView] = useInView(viewportConfig);
  const controls = useAnimation();

  React.useEffect(() => {
    controls.start(inView ? "visible" : "hidden");
  }, [controls, inView]);

  return (
    <Box 
      ref={ref}
      component={motion.div}
      variants={containerVariants}
      initial="hidden"
      animate={controls}
      sx={{ 
        width: '100%',
        minHeight: '100px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        p: 2,
        pt: 0,
      }}
    >
      <Box component={motion.div} variants={itemVariants}>
        <Typography
          variant="h6"
          sx={{
            color: '#1A1A1A',
            fontWeight: 600,
            fontSize: '1.25rem',
            mb: 2
          }}
        >
          Rahim Virani
        </Typography>
      </Box>

      <Box component={motion.div} variants={itemVariants}>
        <Typography
          variant="body1"
          sx={{
            color: '#666',
            mb: 2
          }}
        >
          1728 46 St NW, Calgary, AB T3B 1B2 
        </Typography>
      </Box>

      <Box component={motion.div} variants={itemVariants}>
        <Link
          href="mailto:rahim@rahimvirani.ca"
          aria-label="Email Rahim Virani at rahim@rahimvirani.ca"
          sx={{
            display: 'block',
            color: '#0066CC',
            textDecoration: 'none',
            mb: 2,
            '&:hover': {
              textDecoration: 'underline'
            }
          }}
        >
          rahim@rahimvirani.ca
        </Link>
      </Box>
      <Box component={motion.div} variants={itemVariants}>
        <Link
          href="https://www.rahimvirani.ca"
          aria-label="Visit Rahim Virani's website"
          sx={{
            display: 'block',
            color: '#0066CC',
            textDecoration: 'none',
            mb: 2,
            '&:hover': {
              textDecoration: 'underline'
            }
          }}
        >
          www.rahimvirani.ca
        </Link>
      </Box>

      <Box component={motion.div} variants={itemVariants}>
        <Typography
          variant="body1"
          sx={{
            color: '#666'
          }}
        >
          (403) 471-3552
        </Typography>
      </Box>
    </Box>
  );
};

export default OfficeInfo; 